var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ on: _vm.on },attrs:{"popup":""}},[_c('div',{staticClass:"dim"}),_c('div',{staticClass:"holder"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }